/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PracticeBranchInfoDto } from './PracticeBranchInfoDto';
import {
    PracticeBranchInfoDtoFromJSON,
    PracticeBranchInfoDtoFromJSONTyped,
    PracticeBranchInfoDtoToJSON,
    PracticeBranchInfoDtoToJSONTyped,
} from './PracticeBranchInfoDto';

/**
 * 
 * @export
 * @interface RequestDetailDto
 */
export interface RequestDetailDto {
    /**
     * Request ID
     * @type {string}
     * @memberof RequestDetailDto
     */
    id: string;
    /**
     * Practice ID
     * @type {string}
     * @memberof RequestDetailDto
     */
    practiceId: string;
    /**
     * Practice name
     * @type {string}
     * @memberof RequestDetailDto
     */
    practiceName: string;
    /**
     * Request status
     * @type {string}
     * @memberof RequestDetailDto
     */
    status: RequestDetailDtoStatusEnum;
    /**
     * Request date
     * @type {string}
     * @memberof RequestDetailDto
     */
    requestedAt: string;
    /**
     * Approval date
     * @type {string}
     * @memberof RequestDetailDto
     */
    approvedAt?: string;
    /**
     * Revocation date
     * @type {string}
     * @memberof RequestDetailDto
     */
    revokedAt?: string;
    /**
     * Practice branches
     * @type {Array<PracticeBranchInfoDto>}
     * @memberof RequestDetailDto
     */
    branches: Array<PracticeBranchInfoDto>;
}


/**
 * @export
 */
export const RequestDetailDtoStatusEnum = {
    Requesting: 'requesting',
    ActiveSharing: 'active_sharing',
    Revoked: 'revoked'
} as const;
export type RequestDetailDtoStatusEnum = typeof RequestDetailDtoStatusEnum[keyof typeof RequestDetailDtoStatusEnum];


/**
 * Check if a given object implements the RequestDetailDto interface.
 */
export function instanceOfRequestDetailDto(value: object): value is RequestDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practiceId' in value) || value['practiceId'] === undefined) return false;
    if (!('practiceName' in value) || value['practiceName'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('requestedAt' in value) || value['requestedAt'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    return true;
}

export function RequestDetailDtoFromJSON(json: any): RequestDetailDto {
    return RequestDetailDtoFromJSONTyped(json, false);
}

export function RequestDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practiceId': json['practiceId'],
        'practiceName': json['practiceName'],
        'status': json['status'],
        'requestedAt': json['requestedAt'],
        'approvedAt': json['approvedAt'] == null ? undefined : json['approvedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'branches': ((json['branches'] as Array<any>).map(PracticeBranchInfoDtoFromJSON)),
    };
}

export function RequestDetailDtoToJSON(json: any): RequestDetailDto {
    return RequestDetailDtoToJSONTyped(json, false);
}

export function RequestDetailDtoToJSONTyped(value?: RequestDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practiceId': value['practiceId'],
        'practiceName': value['practiceName'],
        'status': value['status'],
        'requestedAt': value['requestedAt'],
        'approvedAt': value['approvedAt'],
        'revokedAt': value['revokedAt'],
        'branches': ((value['branches'] as Array<any>).map(PracticeBranchInfoDtoToJSON)),
    };
}

